import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  IconButton,
} from "@mui/material";
import React from "react";

export interface FinalizingTreatmentPlanModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  isConfirming?: boolean;
}

export const FinalizingTreatmentPlanModal: React.FC<
  FinalizingTreatmentPlanModalProps
> = ({ open, onClose, onConfirm, isConfirming = false }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="finalizing-treatment-plan-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="finalizing-treatment-plan-title">
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" component="span">
            Finalizing Treatment Plan
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            size="small"
            disabled={isConfirming}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Once confirmed, this treatment plan will be considered final and
          cannot be changed. By proceeding, you agree to be legally bound to the
          details outlined in the plan.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="inherit"
          disabled={isConfirming}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          disabled={isConfirming}
        >
          {isConfirming ? "Confirming..." : "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FinalizingTreatmentPlanModal;
